module.exports = __webpack_public_path__ + "static/media/notify.4b48d6f8.svg";